export const topics = [
  {
    id: "dagongren-cizhi-xin-wenxue",
    title: "「这班谁爱上谁上」：打工人辞职信文学大赏",
    summary:
      "从一句话撂挑子到整篇文言文，辞职信在网友手里被玩成了文学体裁。我们整理了这一季最好笑的几封，以及它们各自的后续梗。",
    category: "work",
    categoryName: "打工人日常",
    tags: ["辞职信", "打工人", "职场梗", "后续梗"],
    heat: 128500,
    cover:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20tiny%20office%20desk%20with%20a%20flying%20paper%20letter%20and%20abstract%20speech%20bubbles%20on%20a%20warm%20coral%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=chigua-cover-work-01&orientation=landscape",
    author: "吃瓜编辑组",
    date: "2026-09-08",
    readTime: 6,
    intro:
      "辞职这件事，本来是职场里最严肃的一步，但在网友手里，它先变成了一场文笔比赛。有人三行字收工，有人写了一整篇赋，还有人干脆做成 PPT。下面这份整理，按「杀伤力」从轻到重排序。",
    sections: [
      {
        id: "s1",
        heading: "第一层：礼貌但坚决型",
        paragraphs: [
          "「感谢公司这几年的照顾，我决定去做一件一直想做但没时间做的事——好好睡觉。」这类辞职信的特点是情绪克制、理由抽象，读完让人挑不出毛病，却又隐隐觉得对方早就准备好了。",
          "它的后续梗通常出现在同事的模仿里：第二天办公室会冒出好几封格式一样的假辞职信，只把结尾的「睡觉」换成「吃饭」「养猫」「追完这部剧」。",
        ],
      },
      {
        id: "s2",
        heading: "第二层：长篇叙事型",
        paragraphs: [
          "再往上一个段位，是把辞职信写成了一篇完整的散文：从入职第一天的天气写到最后一次加班的外卖单，中间穿插领导语录与项目代号。读者往往不是 HR，而是被转发到群里的全体同事。",
          "这类作品的衍生玩法是「朗读挑战」，有人用播音腔念、有人用方言念，念到一半自己先笑场。二创的版本通常会给原文配上背景音乐和分镜，播放量常常比原文高好几倍。",
        ],
      },
      {
        id: "s3",
        heading: "第三层：玄学与文言文",
        paragraphs: [
          "最出圈的一档，是用文言文或半文半白写的辞职信：开头先谢天地，中间自省才疏，结尾祝福公司蒸蒸日上，通篇只有一个意思——我不干了。文采越好，反差越强。",
          "这一支流派的后续，往往不再是辞职信本身，而是「用文言文写日常」的泛化二创：写请假、写点外卖、写拒绝加班，句式越工整越好笑。",
        ],
      },
    ],
    takeaways: [
      "辞职信梗的核心笑点在于「严肃形式 + 轻松理由」的反差。",
      "传播高峰通常出现在周一上午与周日晚间。",
      "后续梗多由同事的模仿与方言朗读接力完成。",
    ],
    memeIds: ["m1", "m5"],
    relatedIds: ["pinglunqu-shenping", "regeng-shengming-zhouqi"],
  },
  {
    id: "biaobao-zouhong-jianshi",
    title: "一张图怎么火遍全网？表情包走红简史",
    summary:
      "你可能天天在用它，却不知道它从哪来。这一期我们顺着时间线，拆解一张表情包从诞生、被改写，到成为「聊天必备」的全过程。",
    category: "meme",
    categoryName: "表情包",
    tags: ["表情包", "出处考据", "热梗溯源"],
    heat: 96400,
    cover:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20stacked%20round%20emoji%20faces%20and%20sticker%20sheets%20floating%20on%20a%20sunflower%20yellow%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=chigua-cover-meme-02&orientation=landscape",
    author: "梗图考据室",
    date: "2026-09-05",
    readTime: 7,
    intro:
      "表情包的生命周期比大多数人以为的要长。一张图往往要经历「原始截图 → 抠图加字 → 换脸二改 → 做成贴纸」四个阶段，才算真正进入公共语料库。",
    sections: [
      {
        id: "s1",
        heading: "阶段一：原始素材从哪来",
        paragraphs: [
          "绝大多数表情包的原料都不是为表情包而拍：一段采访里的意外表情、一次直播里的口误、一张旧剧照。素材走红的关键不是好看，而是「情绪指向明确」——一眼就知道该在什么场合用。",
          "这个阶段的图片通常还很粗糙，甚至带着字幕和水印。真正让它扩散的，是第一批愿意把它存进相册的普通用户。",
        ],
      },
      {
        id: "s2",
        heading: "阶段二：加字与换脸",
        paragraphs: [
          "当一张图被反复转发，就会有人开始给它配文。配文越短越好，最好能覆盖多个场景，于是「累了」「好的」「你说得对」这类万能文案应运而生。",
          "换脸与二改是第二个爆发点。同一张底图，配上不同的脸和不同的字，就能分裂成一整个家族。到这一步，它已经脱离原出处，成为一个独立的符号。",
        ],
      },
      {
        id: "s3",
        heading: "阶段三：进入日常聊天",
        paragraphs: [
          "最终考验是「顺手」：用户不需要思考就能找到并使用它。能通过这一关的表情包，才算真正活了下来，其余的会在两周内被遗忘。",
          "如果你想判断一张新兴表情包能不能长红，可以观察它有没有出现「无需配文也能用」的版本——这通常是从热梗变成基础设施的信号。",
        ],
      },
    ],
    takeaways: [
      "走红关键不是画质，而是情绪指向是否明确。",
      "万能文案与换脸二改是两次主要爆发点。",
      "「无需配文即可使用」是长红标志。",
    ],
    memeIds: ["m2", "m3", "m6"],
    relatedIds: ["erchuang-lianxuju", "regeng-shengming-zhouqi"],
  },
  {
    id: "erchuang-lianxuju",
    title: "二创天花板：网友把一句台词改成了连续剧",
    summary:
      "一句随口台词，被网友接成了十二集连续剧，还自带片头、人物小传和大结局。本期聊透这股「一句话续写」的二创风潮。",
    category: "recreate",
    categoryName: "二创二改",
    tags: ["二创二改", "台词", "连续剧", "脑洞"],
    heat: 88700,
    cover:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20film%20clapperboard%20and%20stacked%20storyboard%20cards%20on%20a%20lime%20green%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=chigua-cover-recreate-03&orientation=landscape",
    author: "脑洞收容所",
    date: "2026-09-02",
    readTime: 5,
    intro:
      "「一句话续写」的门槛低到离谱，天花板却高得吓人。规则很简单：给你一句台词，往下接。有人接三句就收，有人接了十二集还意犹未尽。",
    sections: [
      {
        id: "s1",
        heading: "为什么这句台词好接",
        paragraphs: [
          "能被接成连续剧的台词，通常有一个共同点：信息量模糊但画面感极强。它给出了情绪，却没给出结局，于是每一个人都能往里填自己的想象。",
          "反过来，信息太完整的台词很难接——观众已经没有创作空间了。这也是很多「名场面」没能形成二创潮的原因。",
        ],
      },
      {
        id: "s2",
        heading: "从接龙到体系",
        paragraphs: [
          "最初只是评论区里的接龙，几楼之后就有人开始排「剧情线」，再往后出现了人物小传、世界观设定，甚至有人做了一张剧集海报。到这里，二创已经自成体系。",
          "比较有意思的是，不同平台的二创会长出不同的形态：有的擅长长文叙事，有的擅长配音，有的直接做成动画分镜。同一句台词，在三个地方能长出三棵树。",
        ],
      },
    ],
    takeaways: [
      "易接的台词 = 情绪明确 + 结局留白。",
      "二创会随平台形态分化出不同表达方式。",
      "结构化（人物、世界观）是二创走向长红的信号。",
    ],
    memeIds: ["m4", "m7"],
    relatedIds: ["biaobao-zouhong-jianshi", "pinglunqu-shenping"],
  },
  {
    id: "pinglunqu-shenping",
    title: "评论区比正文好看？神评合集第十二期",
    summary:
      "本期精选十五条评论区高赞回复，涵盖阴阳怪气、神补刀、一本正经胡说八道三大流派，附「为什么好笑」的简要拆解。",
    category: "comment",
    categoryName: "评论神评",
    tags: ["神评", "评论区", "神补刀", "幽默"],
    heat: 76200,
    cover:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20overlapping%20chat%20bubbles%20with%20hearts%20and%20thumbs%20up%20on%20a%20warm%20orange%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=chigua-cover-comment-04&orientation=landscape",
    author: "评论区观察员",
    date: "2026-08-30",
    readTime: 4,
    intro:
      "一条好的神评，往往不是因为文采，而是因为它比正文更早地说出了大家心里那句话。本期我们按流派整理，并标注每条为什么好笑。",
    sections: [
      {
        id: "s1",
        heading: "流派一：神补刀",
        paragraphs: [
          "特点是接在别人已经很惨的话后面，再加一句更惨的。笑点来自节奏：补刀的时间点比内容更重要，慢半拍就变成冒犯。",
          "这类评论的高赞往往出现在楼层很靠后的位置，因为它需要前文铺垫。",
        ],
      },
      {
        id: "s2",
        heading: "流派二：一本正经胡说八道",
        paragraphs: [
          "用极其严肃的语气描述一件荒诞的事，全程不笑。判断标准是：如果去掉语气词还能成立，那它就是合格的作品。",
          "这一流派的二创空间很大，很多会被截取出来做成单独的图文合集。",
        ],
      },
      {
        id: "s3",
        heading: "流派三：人间清醒",
        paragraphs: [
          "不搞笑，但一句戳中要害，靠共鸣拿赞。它通常是整条评论区里最冷静的那一条，也因此最容易被转发到别的平台。",
          "如果你想在评论区脱颖而出，这三个流派里，「人间清醒」的门槛最低、回报最稳定。",
        ],
      },
    ],
    takeaways: [
      "神评的关键是时机与共鸣，而非文采。",
      "神补刀依赖前文铺垫，位置通常靠后。",
      "「人间清醒」型最容易被跨平台转发。",
    ],
    memeIds: ["m5", "m8"],
    relatedIds: ["dagongren-cizhi-xin-wenxue", "erchuang-lianxuju"],
  },
  {
    id: "tuwei-qinghua-jinhua",
    title: "土味情话的二创进化史：从社死到真香",
    summary:
      "曾经让人尴尬到脚趾抠地的土味情话，如今被改造成了台词、短剧和表情包。这中间到底发生了什么？",
    category: "recreate",
    categoryName: "二创二改",
    tags: ["土味情话", "二创", "反差", "真香"],
    heat: 68400,
    cover:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20red%20heart%20and%20abstract%20candy%20shapes%20with%20sparkles%20on%20a%20coral%20pink%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=chigua-cover-recreate-05&orientation=landscape",
    author: "吃瓜编辑组",
    date: "2026-08-26",
    readTime: 5,
    intro:
      "土味情话在几年前还是「社死素材」，现在却成了通行证。反转的关键不在于情话本身变好笑了，而在于大家开始用一种新的方式使用它。",
    sections: [
      {
        id: "s1",
        heading: "第一次转变：当事人视角变成围观者视角",
        paragraphs: [
          "早期土味情话的笑点建立在「说的人很认真」上，观众替他尴尬。当创作者开始把镜头对准围观者，笑点就从尴尬变成了调侃。",
          "视角一换，情话不再是需要被原谅的失误，而是一个可以随手搬运的素材。",
        ],
      },
      {
        id: "s2",
        heading: "第二次转变：认真演",
        paragraphs: [
          "当有人用完全专业的表演去呈现最土的内容，反差被拉到最大，反而产生了美感。这也是「土到极致就是潮」的由来。",
          "至此，这条线彻底完成从社死到真香的闭环，并衍生出短剧、配音、表情包等大量二创。",
        ],
      },
    ],
    takeaways: [
      "笑点从「当事人尴尬」转向「围观者调侃」。",
      "专业表演 × 土味内容 = 最大反差。",
      "完成转变后衍生出短剧、配音等丰富二创。",
    ],
    memeIds: ["m6"],
    relatedIds: ["erchuang-lianxuju", "biaobao-zouhong-jianshi"],
  },
  {
    id: "mofangxiu-fanche-mingchangmian",
    title: "模仿秀翻车名场面：越努力越心酸",
    summary:
      "模仿是热梗传播最快的方式，也是最容易翻车的方式。本期盘点几个「认真到让人心疼」的翻车现场，并分析为什么会翻。",
    category: "hot",
    categoryName: "热梗追踪",
    tags: ["模仿", "翻车", "名场面", "热梗"],
    heat: 61300,
    cover:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20two%20mirrored%20geometric%20characters%20and%20a%20confetti%20burst%20on%20a%20mustard%20yellow%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=chigua-cover-hot-06&orientation=landscape",
    author: "名场面档案馆",
    date: "2026-08-22",
    readTime: 4,
    intro:
      "翻车之所以好笑，是因为它同时包含了「努力」和「失败」两种情绪。观众笑完之后，往往还会对当事人产生一种奇怪的亲切感。",
    sections: [
      {
        id: "s1",
        heading: "为什么会翻车",
        paragraphs: [
          "最常见的原因是节奏错位：模仿者抓住了原版的词，却没抓住原版的停顿。热梗的灵魂往往在那半秒的沉默里。",
          "第二种是「过度还原」，把每个细节都做到位，反而失去了松弛感，看起来像在考试。",
        ],
      },
      {
        id: "s2",
        heading: "翻车之后",
        paragraphs: [
          "有意思的是，很多翻车现场比成功的模仿传播更广。当事人如果大方接梗，往往能顺势涨一波好感，甚至把翻车做成个人标签。",
          "这也是热梗生态里善意的一面：只要你敢接，观众通常愿意陪你玩。",
        ],
      },
    ],
    takeaways: [
      "翻车的核心是节奏错位或过度还原。",
      "大方接梗能把翻车转化为个人标签。",
      "观众对「努力过的失败」容忍度很高。",
    ],
    memeIds: ["m7", "m1"],
    relatedIds: ["regeng-shengming-zhouqi", "tuwei-qinghua-jinhua"],
  },
  {
    id: "regeng-shengming-zhouqi",
    title: "一个热梗从爆火到过气，只要七天？",
    summary:
      "我们统计了近期一百个热梗的传播曲线，发现大部分梗的高峰都在第四天。搞懂这个节奏，你就能判断下一个梗值不值得追。",
    category: "hot",
    categoryName: "热梗追踪",
    tags: ["热梗", "生命周期", "数据观察"],
    heat: 55900,
    cover:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20rising%20line%20chart%20made%20of%20floating%20colorful%20cubes%20on%20a%20lime%20green%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=chigua-cover-hot-07&orientation=landscape",
    author: "数据吃瓜局",
    date: "2026-08-18",
    readTime: 6,
    intro:
      "热梗是有生命周期的，而且比想象中短。把一百个梗的传播量画成曲线后，一条高度相似的形状出现了：缓慢爬升、第四天见顶、第七天基本回落。",
    sections: [
      {
        id: "s1",
        heading: "为什么是第四天",
        paragraphs: [
          "第一天是种子期，只在核心圈子流传；第二、三天进入破圈期，二创开始大量出现；第四天达到传播峰值，此时几乎所有平台都能刷到它。",
          "峰值之后，内容开始同质化，用户产生疲劳，曲线快速下滑。第七天左右，它会被新的梗顶替。",
        ],
      },
      {
        id: "s2",
        heading: "例外与长尾",
        paragraphs: [
          "少数梗能活过两周，通常是成功沉淀成了表情包或固定用法——它们不再依赖事件本身，而是变成了语言工具。",
          "所以判断一个梗值不值得投入精力，看它有没有长出「可脱离原事件的用法」，比看当下的热度更靠谱。",
        ],
      },
    ],
    takeaways: [
      "多数热梗在第四天见顶、第七天回落。",
      "破圈期（第二、三天）是二创红利期。",
      "沉淀为表情包的梗拥有更长长尾。",
    ],
    memeIds: ["m3", "m8"],
    relatedIds: ["biaobao-zouhong-jianshi", "ai-fanchang-regeng"],
  },
  {
    id: "ai-fanchang-regeng",
    title: "AI 翻唱热梗大赏：听完我沉默了",
    summary:
      "当 AI 开始处理热梗，事情变得又离谱又合理。本期整理了 AI 翻唱、AI 配音和 AI 二创三类玩法，以及它们的争议点。",
    category: "ai",
    categoryName: "AI 玩梗",
    tags: ["AI", "翻唱", "配音", "二创"],
    heat: 49700,
    cover:
      "https://readdy.ai/api/search-image?query=playful%20vibrant%203D%20render%20of%20a%20friendly%20robot%20head%20with%20sound%20waves%20and%20music%20notes%20on%20a%20teal%20green%20studio%20background%2C%20soft%20studio%20lighting%2C%20bold%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=chigua-cover-ai-08&orientation=landscape",
    author: "机器吃瓜",
    date: "2026-08-14",
    readTime: 5,
    intro:
      "AI 玩梗的好处是快，坏处也在于太快——快到大家还没想清楚该怎么用它。本期不做评测，只做现象整理。",
    sections: [
      {
        id: "s1",
        heading: "AI 翻唱：梗的二次配乐",
        paragraphs: [
          "一段热梗音频被换上完全不同的曲风与声线，听感上的反差本身就是笑点。制作门槛被压到极低之后，产量迅速超过了人工二创。",
          "争议点集中在声音授权上。多数创作者的做法是只处理公共素材，不涉及具体个人的声音特征。",
        ],
      },
      {
        id: "s2",
        heading: "AI 配音与短剧",
        paragraphs: [
          "把热梗写成小剧本，交给 AI 配音并配上分镜，几分钟就能产出一条短剧。这类作品的优点是产量稳定，缺点是容易同质化。",
          "真正出圈的 AI 二创，往往还是一句话写得好——工具只是把想法实现得更快了。",
        ],
      },
    ],
    takeaways: [
      "AI 降低门槛，但创意依然决定成败。",
      "声音授权是当前主要争议点。",
      "纯 AI 作品同质化快，需靠文案破局。",
    ],
    memeIds: ["m2", "m4"],
    relatedIds: ["regeng-shengming-zhouqi", "erchuang-lianxuju"],
  },
];